import React from 'react';
import img1 from '../../assets/images/icon/icon1.png';
import img2 from '../../assets/images/icon/icon2.png';
import img3 from '../../assets/images/icon/icon3.png';
import img4 from '../../assets/images/icon/icon4.png';

const data = [
    {
        id: 1,
        img: img1,
        title: 'AI Algo Trading',
        desc: 'Execute trades automatically using AI-based strategies.'
    },
    {
        id: 2,
        img: img2,
        title: '24/7 Monitoring',
        desc: 'Non-stop market observation and action.'
    },
    {
        id: 3,
        img: img3,
        title: 'Smart Risk Control',
        desc: 'Automated stop-loss and capital protection.'
    },
    {
        id: 4,
        img: img4,
        title: 'Secure Payments',
        desc: 'Trade confidently with crypto-supported payments.'
    }
];

function Speciality() {
    return (
        <section className="speciality">
            <div className="container">
                <div className="block-text center">
                    <h6 className="sub-heading"><span>Our Speciality</span></h6>
                    <h3 className="heading">Smart Features for Profitable Trading</h3>
                    <p className="text">
                        PipPlus Tech simplifies forex with intelligent automation, risk control, and real-time insights.
                    </p>
                </div>
                <div className="row">
                    {data.map((item, index) => (
                        <div className="col-xl-3 col-md-6" key={item.id}>
                            <div className="speciality-box">
                                <div className="icon">
                                    <img src={item.img} alt={item.title} />
                                </div>
                                <h5>{item.title}</h5>
                                <p>{item.desc}</p>
                                <span className="number">{String(index + 1).padStart(2, '0')}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Speciality;
